<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_help_circle)">
            <path d="M10 15.666C10.5868 15.666 11.0625 15.1903 11.0625 14.6035C11.0625 14.0167 10.5868 13.541 10 13.541C9.4132 13.541 8.9375 14.0167 8.9375 14.6035C8.9375 15.1903 9.4132 15.666 10 15.666Z" fill="currentColor"/>
            <path d="M10.0013 11.4167V10.7083C11.5658 10.7083 12.8346 9.59802 12.8346 8.22917C12.8346 6.86031 11.5658 5.75 10.0013 5.75C8.43677 5.75 7.16797 6.86031 7.16797 8.22917V8.58333" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_help_circle">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>
